import axios from 'axios'
import { authZeroFetch, AxiosPost, AxiosPut, AxiosDelete } from './AuthZeroFetch'

const SaveClient = (data) => {
    return authZeroFetch(AxiosPost, '/api/clients/', data)
}

const GetClientCounts = () => {
    return authZeroFetch(axios.get, '/api/clients/counts')
}

const GetClient = (id) => {
    return authZeroFetch(axios.get, '/api/clients/' + id)
}

const GetClientName = (id) => {
    return authZeroFetch(axios.get, '/api/clients/' + id + '/name')
}

const UpdateClient = (id, values) => {
    return authZeroFetch(AxiosPut, '/api/clients/' + id, values)
}

const UpdateClientStatus = (id, newStatus, noPlanReason, planType, premium) => {
    const data = { newStatus, noPlanReason, planType, premium }
    return authZeroFetch(AxiosPut, `/api/clients/${id}/status`, data)
}

const GetClients = (searchTerm, filter) => {
    let baseUrl = '/api/clients'
    let queryParams = ''
    if (searchTerm) {
        queryParams = `${queryParams}&searchTerm=${searchTerm}`
    }
    if (filter) {
        queryParams = `${queryParams}&filter=${filter}`
    }

    // get rid of starting &
    queryParams = queryParams.substring(1)
    return authZeroFetch(axios.get, `${baseUrl}?${queryParams}`)
}

const GetRecentClients = () => {
    return authZeroFetch(axios.get, '/api/clients/recents')
}

const DeleteClient = (id) => {
    return authZeroFetch(AxiosDelete, '/api/clients/' + id)
}

export {
    GetClients,
    GetRecentClients,
    UpdateClientStatus,
    GetClient,
    GetClientName,
    SaveClient,
    UpdateClient,
    DeleteClient,
    GetClientCounts,
}
